var map = {
	"./ActForex-tab-icon.png": "201f",
	"./CTrader-tab-icon.png": "feb9",
	"./CloudTrade-tab-icon.png": "24b8",
	"./DXTrade-tab-icon.png": "b7c8",
	"./MT4-tab-icon.png": "f866",
	"./MT5-tab-icon.png": "7a8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5e0d";